import React from 'react'
import { Inertia } from '@inertiajs/inertia'
import { App } from '@inertiajs/inertia-react'
import { render } from 'react-dom'
import * as Sentry from '@sentry/react'
import { Integrations } from '@sentry/tracing'

import Progress from '@/Helpers/Progress'
import FormProgress from '@/Helpers/FormProgress'
import Http from '@/Helpers/Http'

if (process.env.MIX_ENVIRONMENT === 'production') {
    Sentry.init({
        dsn: 'https://374c531437674af0836ac7e5b60dc9be@o563970.ingest.sentry.io/5719110',
        integrations: [new Integrations.BrowserTracing()],

        // Set tracesSampleRate to 1.0 to capture 100%
        // of transactions for performance monitoring.
        // We recommend adjusting this value in production
        tracesSampleRate: 0.1,
    })

    Inertia.on('navigate', event => {
        if (window.fathom) {
            window.fathom.trackPageview()

            if (
                event &&
                event.detail &&
                event.detail.page &&
                event.detail.page.props &&
                event.detail.page.props.external_scripts &&
                event.detail.page.props.external_scripts.fathom &&
                event.detail.page.props.external_scripts.fathom.enabled &&
                event.detail.page.props.external_scripts.fathom.site_id
            ) {
                window.fathom.setSite('CACHMRRX')
                window.fathom.trackPageview()
                window.fathom.setSite(
                    event.detail.page.props.external_scripts.fathom.site_id
                )
            }
        }
    })
}

const el = document.getElementById('app')

function isExternalFormsDomain() {
    const currentHost = window.location.hostname

    return currentHost.includes('forms.')
}

if (isExternalFormsDomain()) {
    FormProgress.init()
} else {
    Progress.init({
        exclude: [
            'forms.ui.edit',
        ],
    })
}

window.track = (event, context) => {
    Http.post(route('internal.events.store', { event }), context)
}

render(
    <App
        initialPage={JSON.parse(el.dataset.page)}
        resolveComponent={name =>
            import(`./Pages/${name}`).then(module => module.default)
        }
    />,
    el
)
